




















import { Component, Mixins } from 'vue-property-decorator'
import { QBtn } from 'quasar'
import SchoolCreditTable from 'src/components/SchoolCreditTable.vue'
import SchoolCreditCreateModal from 'src/components/SchoolCreditCreateModal.vue'
import { IVxsPromise, vxsActionFetch, vxsDataGetter } from 'vuex-xhr-state'
import { ISchoolCredit, readSchoolCredits } from '../store/school-credit'
import { EPermission } from '../laura-types'
import NotifyMixin from '../plugins/mixins/NotifyMixin'

@Component({
  components: { QBtn, SchoolCreditCreateModal, SchoolCreditTable },
})
export default class SchoolCredit extends Mixins(NotifyMixin) {
  @vxsDataGetter(readSchoolCredits) private readSchoolCredits!: () => ISchoolCredit[]
  @vxsActionFetch(readSchoolCredits) private fetchSchoolCredits!: () => IVxsPromise<ISchoolCredit[]>

  public createModalOpen = false

  public created(): void {
    this.fetchSchoolCredits()
  }

  get schoolCredits(): ISchoolCredit[] {
    if (!this.readSchoolCredits()) return []

    return this.readSchoolCredits()
  }

  public openModal(): void {
    this.createModalOpen = true
  }

  get showCreateButton(): boolean {
    return this.$can('create', EPermission.LIKA_CREDIT)
  }

  public handleSchoolCreditCreated(): void {
    this.showMessage('positive', 'Het schooltegoed is toegevoegd ', 10000)
    this.fetchSchoolCredits()
  }
}
